import React from 'react';
import { motion } from 'framer-motion';
export function PillarsSection() {
  const pillars = [{
    id: 1,
    title: 'Pilar 1: Tratamiento Capilar',
    description: 'Guía natural, pasos exactos, tiempos y repetición inteligente.',
    image: 'https://cdn.magicpatterns.com/uploads/rW4YYCSS9AvNAVXSjAMrYV/HERO_2.png',
    align: 'left'
  }, {
    id: 2,
    title: 'Pilar 2: Spray para Textiles',
    description: 'Cómo tratar peines, sábanas, gorras, sillones y accesorios sin volverte loca.',
    image: 'https://cdn.magicpatterns.com/uploads/g5oF9mhAr4N7UYzKJ9ZdhB/HERO_3.png',
    align: 'right'
  }, {
    id: 3,
    title: 'Pilar 3: Rutina Diaria',
    description: 'Checklist de 14 días para cortar el ciclo y mantener el control.',
    image: 'https://cdn.magicpatterns.com/uploads/nmdRVmn7U2wubbKeyfn71X/HERO_4.png',
    align: 'left'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="space-y-20" data-id="element-141">
          {pillars.map((pilar, index) => <motion.div key={pilar.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${pilar.align === 'right' ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-10 lg:gap-16`} data-id="element-142">
              <div className="flex-1 w-full" data-id="element-143">
                <div className="relative rounded-2xl overflow-hidden shadow-xl group" data-id="element-144">
                  <div className="absolute inset-0 bg-[#1e4d7b]/0 group-hover:bg-[#1e4d7b]/5 transition-colors duration-300" data-id="element-145"></div>
                  <img src={pilar.image} alt={pilar.title} className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-146" />
                </div>
              </div>

              <div className="flex-1 w-full text-center lg:text-left" data-id="element-147">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#1e4d7b] text-white font-bold text-xl mb-6 shadow-md" data-id="element-148">
                  {pilar.id}
                </div>
                <h3 className="text-3xl font-bold text-[#1e4d7b] mb-4" data-id="element-149">
                  {pilar.title}
                </h3>
                <p className="text-xl text-gray-600 leading-relaxed" data-id="element-150">
                  {pilar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}